(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const innerHTML = new DOMParser()
                .parseFromString(text, 'text/html')
                .querySelector('product-recommendations');
            if ( innerHTML && innerHTML.querySelectorAll('.product-item').length > 0 ) {
              this.innerHTML = innerHTML.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sk-cross-sell"] && !Shopify.designMode) return;
  try {
    
(function() {
  const container = document.querySelector('.sk-cross-sell__container[data-url]');
  if (!container) return;
  if ('IntersectionObserver' in window) {
    const obs = new IntersectionObserver((entries) => {
      if (!entries[0].isIntersecting) return;
      obs.unobserve(container);
      fetch(container.dataset.url)
        .then(r => r.text())
        .then(html => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const inner = doc.querySelector('.sk-cross-sell__container');
          if (inner) container.innerHTML = inner.innerHTML;
        });
    }, { rootMargin: '200px' });
    obs.observe(container);
  } else {
    fetch(container.dataset.url)
      .then(r => r.text())
      .then(html => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const inner = doc.querySelector('.sk-cross-sell__container');
        if (inner) container.innerHTML = inner.innerHTML;
      });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sk-judgeme-widget"] && !Shopify.designMode) return;
  try {
    
const jmWidget = document.querySelector('.sk-judgeme-widget');
if (jmWidget && 'IntersectionObserver' in window) {
  const obs = new IntersectionObserver((entries) => {
    if (!entries[0].isIntersecting) return;
    obs.unobserve(jmWidget);
    jmWidget.classList.add('sk-judgeme-widget--visible');
  }, { rootMargin: '300px' });
  obs.observe(jmWidget);
}

  } catch(e) { console.error(e); }
})();
})();
